<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">ALSO BY NJ MOSS</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="content-external-link">All Your Fault</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><span class="content-external-link">Her Final Victim</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><span class="content-external-link">My Dead Husband</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><a class="content-external-link" href="https://geni.us/TheHusbandTrapNJM" target="_blank">The Husband Trap</a></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><a class="content-external-link" href="https://geni.us/TheSecondWife" target="_blank">The Second Wife</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobynjmoss.vue?938427c2